// components/RatingStars.js

export default function RatingStars({
  fullcount = 0,
  quatercount = 0,
  halfcount = 0,
  quaterhalf = 0,
  emptycount = 0,
  score,
}) {
  const CDN = process.env.NEXT_PUBLIC_CDN_ID;
  const renderStars = (count, type, img) =>
    [...Array(count)].map((_, index) => (
      <span key={`${type}-${index}`}>
        <img
          src={`${CDN}static/images/${img}`}
          className="rating_img"
          title="Neighborhood Rating"
          alt="Neighborhood Rating"
          width="30"
          height="30"
        />
      </span>
    ));

  return (
    <div className="rating_section">
      {renderStars(fullcount, "full-star", "rating_full.png")}
      {renderStars(quatercount, "quarter-star", "rating_quater.png")}
      {renderStars(halfcount, "half-star", "rating_half.png")}
      {renderStars(quaterhalf, "quarter-half-star", "rating_quater_half.png")}
      {renderStars(emptycount, "empty-star", "rating_empty.png")}

      <div className="rating_cnt">
        <span className="score_rating">{`${score} /5`}</span>
      </div>
    </div>
  );
}
